import { HttpClient, HttpErrorResponse } from '@angular/common/http';

import { Company } from 'app/models';
import { Injectable } from '@angular/core';
import { MatSnackBar } from '@angular/material/snack-bar';
import { Subject } from 'rxjs';
import { SnackbarType } from 'app/constants/Enums';
import { SnackBarService } from '../snackbar-service/snackbar.service';
import { TranslateService } from '@ngx-translate/core';
import { takeUntil } from 'rxjs/operators';
import { ApiUrl } from 'app/constants/ApiUrls';
import { CompanyService } from '../company-service/company.service';

@Injectable({
  providedIn: 'root',
})
export class ChangeBranchesService {
  private _branches: Company[] = [];
  private onDestroy$ = new Subject<void>();
  
  public loading:boolean = false;

  constructor(
    private _http: HttpClient,
    private _translateService: TranslateService,
    private _companyService: CompanyService,
    private _snackbarService: SnackBarService,
    public snackBar: MatSnackBar
  ) {}

  addBranch(branch: Company): void {
    this._branches.push(branch);
  }

  removeBranch(branch: Company): void {
    const branchIndex: number = this._branches.findIndex(
      (b) => b.accountId === branch.accountId
    );
    if (branchIndex === -1) {
      return;
    }
    this._branches.splice(branchIndex, 1);
  }

  clearBranches(): void {
    this._branches = [];
  }

  getBranches(): Company[] {
    return this._branches;
  }

  updateUserBranches(users: any[], companyId: string): void { 
    this.loading = true;
    users.forEach((user) => {
      user.companyId = companyId;
    })
    this._http.put(`${ApiUrl.companies}/${companyId}/Profiles/Branches`, users).subscribe({
      next:() => {
        this._companyService.getCompanyBranchesWithUsers(companyId);
        let success = '';
        let successMsg = '';
        this._translateService
          .get('SNACKBAR.success')
          .pipe(takeUntil(this.onDestroy$))
          .subscribe((value) => (success = value));
        this._translateService
          .get('SNACKBAR.user_branch_assign')
          .pipe(takeUntil(this.onDestroy$))
          .subscribe((value) => (successMsg = value));
            this.loading =false;
        this._snackbarService.showSnackbar(
          SnackbarType.success,
          success,
          successMsg
        );
      },
      error:(error) => this._handleError(error)
    }
    );
  }

  private _handleError(error: HttpErrorResponse): void {
    this.loading = false;
    let message = '';
    let genericErrorMsg = "";
    this._translateService
    .get('ERROR_TRY_LATER')
    .pipe(takeUntil(this.onDestroy$))
    .subscribe((value) => (genericErrorMsg = value));
    if (error.error instanceof ErrorEvent) {
      message = `[users-service] ERROR: ${error.error.message}`;
      console.error(message);
    } else {
      message = `[users-service] STATUS: ${error.status}, ERROR: ${error.message}`;
      console.error(message);
    }
    this._snackbarService.showSnackbar(SnackbarType.error, 'Error', genericErrorMsg);
  }
}
